import { render, staticRenderFns } from "./BlogArticleHero.vue?vue&type=template&id=b67fef26&"
import script from "./BlogArticleHero.vue?vue&type=script&lang=js&"
export * from "./BlogArticleHero.vue?vue&type=script&lang=js&"
import style0 from "./BlogArticleHero.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports